import { AfterViewInit, ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ContactProvider } from 'src/app/providers/contact.provider';
import { SEOService } from 'src/app/services/seo.service';
import testimonials from 'src/assets/json/testimonials.json';

@Component({
  selector: 'component-home',
  templateUrl: './home.page.html',
  styleUrls: ['./home.page.css']
})
export class HomePage implements OnInit {
  formSubmit : any;
  formSuccess: boolean = false;
  loading: boolean = false;
  images: any[];
  testimonials: any[] = testimonials;
  captchaResolved = false;
  
  constructor(private contact: ContactProvider, private SEOService: SEOService, private route: ActivatedRoute) { }

  ngOnInit(): void {
  }

  checkCaptcha(captchaResponse : string) {
    this.captchaResolved = (captchaResponse && captchaResponse.length > 0) ? true : false
  } 

  checkEnabled(form){
    if(form.valid && !this.loading && this.captchaResolved) {
      return '';
    } else {
      return 'disabled';
    }
  }

  submitContact = (form) =>{

    if (!form.valid) 
    { 
      return; 
    }
    else { 
      this.loading = true; 

      var data = {
        FullName: form.value.name,
        Email: form.value.email,
        MobileNo: "",
        Message: form.value.message
      };

      this.contact
          .sendContactUsAsync("utils/sendcontactusasync", data)
          .subscribe(
          data => { 
            this.loading = false;
            this.formSuccess = true; 
          },
          error => { 
            this.loading = false;
            this.formSuccess = false; 
            console.log(error);
          }
      );
    } 
  }
}
